import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import {
  Table,
  LoadingHavaianas,
  type HeadItemType,
  INITIAL_PAGE,
  ITEMS_PER_PAGE,
  Pagination,
  type PaginationParams
} from 'components'
import { ModalContentLayout } from 'layouts/ModalContentLayout'
import { getKeyAccountTracking } from 'services/keyAccounts'

import * as S from './styles'
import { toast } from 'react-toastify'
import type { KeyAccountTracking } from 'services/keyAccounts/types'

interface TrackingModalProps {
  setOpen: Dispatch<SetStateAction<boolean>>
}

export const TrackingModal = ({ setOpen }: TrackingModalProps) => {
  const [loading, setLoading] = useState(true)
  const [pagination, setPagination] = useState<PaginationParams>({
    currentPage: INITIAL_PAGE,
    totalItems: 0
  })
  const [trackingData, setTrackingData] = useState<KeyAccountTracking[]>([])

  const tableLabels: HeadItemType[] = [
    { label: 'Data', columnName: 'date' },
    { label: 'Hora', columnName: 'time' },
    { label: 'Usuário', columnName: 'user' },
    { label: 'Cliente', columnName: 'name' },
    { label: 'Código SAP', columnName: 'id' },
    { label: 'CNPJ', columnName: 'cnpj' },
    { label: 'Ação', columnName: 'action' }
  ]

  const fetchTrackingData = async (page: number) => {
    setLoading(true)

    try {
      const { pagination, data } = await getKeyAccountTracking({
        page,
        perPage: ITEMS_PER_PAGE
      })

      setPagination(pagination)
      setTrackingData(data)
    } catch (error) {
      toast.error('Erro ao carregar tracking. Tente novamente mais tarde.')

      setOpen(false)
      setPagination({ currentPage: INITIAL_PAGE, totalItems: 0 })
      setTrackingData([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchTrackingData(pagination.currentPage)
  }, [pagination.currentPage])

  const tableData = () => {
    if (!trackingData.length) return []

    return trackingData.map((tracking) => {
      return {
        id: tracking.id,
        content: [
          tracking.dateFormatted,
          tracking.timeFormatted,
          tracking.user,
          tracking.name,
          tracking.idSapCustomer,
          tracking.cnpjFormatted,
          tracking.action
        ]
      }
    })
  }

  const handleClose = () => {
    setPagination({ ...pagination, currentPage: INITIAL_PAGE })
    setOpen(false)
  }

  const handlePageChange = (page: number) => {
    setPagination({
      ...pagination,
      currentPage: page
    })
  }

  return (
    <ModalContentLayout
      title="Tracking"
      titleSize={22}
      width={'95vw'}
      closeButton
      description="Acompanhe o histórico completo de alterações realizadas."
      closeAction={handleClose}
    >
      {loading ? (
        <S.LoadingWrapper>
          <LoadingHavaianas />
        </S.LoadingWrapper>
      ) : (
        <>
          <Table
            headData={tableLabels}
            bodyData={tableData()}
            rowHeight={48}
            fixedHead
            maxHeight={667}
          />
          <Pagination
            currentPage={pagination?.currentPage}
            numberOfItems={pagination?.totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            setCurrentPage={handlePageChange}
          />
        </>
      )}
    </ModalContentLayout>
  )
}
